/**
 * 📦 Fissal Prime Mobile Client Version Manifest
 * Managed and stamped during build by scripts/build-fissal-apk.sh
 */

export interface AppVersionManifest {
  version: string;
  buildCode: number;
  buildTime: string;
  buildTimestamp: number;
}

export const CURRENT_APP_VERSION: AppVersionManifest = {
  version: "2.1.0",
  buildCode: 210,
  buildTime: "2026-10-31T07:01:51.000Z",
  buildTimestamp: 1793430111749
};
